export const POST_CONTACT_US_BEGIN = "POST_CONTACT_US_BEGIN";
export const POST_CONTACT_US_SUCCESS = "POST_CONTACT_US_SUCCESS";
export const POST_CONTACT_US_ERROR = "POST_CONTACT_US_ERROR";

export const GET_CONTACT_US_BEGIN = "GET_CONTACT_US_BEGIN";
export const GET_CONTACT_US_SUCCESS = "GET_CONTACT_US_SUCCESS";
export const GET_CONTACT_US_ERROR = "GET_CONTACT_US_ERROR";
